module.exports = __webpack_public_path__ + "img/remove-fill.e3c87f93.svg";